import script from "./m-input-search-pop.vue?vue&type=script&setup=true&lang=js"
export * from "./m-input-search-pop.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__